export default __webpack_public_path__ + "static/media/POPPINS-MEDIUM.2d6ae121.TTF";